module.exports = __webpack_public_path__ + "media/images/favicons/favicon-f10610cf3a9de92e0dcb6f94fd3906a4.ico";